import { render, staticRenderFns } from "./countryNotice.vue?vue&type=template&id=027c4092&scoped=true"
import script from "./countryNotice.vue?vue&type=script&lang=js"
export * from "./countryNotice.vue?vue&type=script&lang=js"
import style0 from "./countryNotice.vue?vue&type=style&index=0&id=027c4092&prod&lang=scss&scoped=true"
import style1 from "./countryNotice.vue?vue&type=style&index=1&id=027c4092&prod&scoped=true&lang=css"
import style2 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "./countryNotice.vue?vue&type=style&index=3&id=027c4092&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027c4092",
  null
  
)

export default component.exports